import { render, staticRenderFns } from "./QueryQRRecords.vue?vue&type=template&id=1023fc60&scoped=true"
import script from "./QueryQRRecords.vue?vue&type=script&lang=js"
export * from "./QueryQRRecords.vue?vue&type=script&lang=js"
import style0 from "./QueryQRRecords.vue?vue&type=style&index=0&id=1023fc60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023fc60",
  null
  
)

export default component.exports